import { Flex } from '@servicetitan/anvil2';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import * as Styles from './centered.module.less';

interface CenteredProps {
    fullPage?: boolean;
    className?: string;
    children?: ReactNode;
}

export const Centered: FC<CenteredProps> = ({ children, className, fullPage }) => (
    <Flex
        className={classNames(fullPage ? Styles.fullViewport : Styles.fill, className)}
        direction="column"
        justifyContent="center"
        alignItems="center"
    >
        {children}
    </Flex>
);
